import React from 'react';
import { array, object, string } from 'prop-types';
import cx from 'classnames';
import ResponsiveImage from '../ResponsiveImage';
import RichText from '../Prismic/RichText';
import StarRating from 'wonderbly-components/lib/StarRating';
import isString from 'lodash/isString';
import './HeroII.scss';

// Check if the select option from Prismic will need to render a "value prop"
// These values are constant
const isUsingValueProps = valuePropIcon =>
  valuePropIcon !== 'none' &&
  valuePropIcon !== '4 star rating' &&
  valuePropIcon !== '5 star rating';

const iconDict = {
  '4 star rating': '4',
  '5 star rating': '5'
};

const icons = icon => iconDict[icon] || icon;

const Extras = props => {
  const hasValuePropIcon = isUsingValueProps(props.icon);
  if (hasValuePropIcon && props.content) {
    return (
      <div
        className={cx('hero-ii-value-prop', {
          [`color-${props.contentColor}`]: props.contentColor,
        })}>
        <i className={`ss-${props.icon} padded-right-tiny`} />
        {props.content}
      </div>
    );
  }
  if (!hasValuePropIcon && props.icon !== 'none') {
    return (
      <div className="hero-ii-rating">
        <StarRating stars={icons(props.icon)} />
      </div>
    );
  }
  return null;
};

Extras.propTypes = {
  contentColor: string,
  content: string,
  icon: string.isRequired,
};

const HeroII = props => (
  <section
    className="hero-ii"
    style={{ backgroundColor: props.backgroundColor }}>
    <div className="hero-ii-image">
      <ResponsiveImage images={props.backgroundImage} alt="" />
    </div>
    <div
      className={cx({
        'hero-ii-wrapper': props.mobileImageLayout === 'image behind content',
        'hero-ii-wrapper--bottom-space':
          props.mobileImageLayout === 'image under content',
      })}>
      <div className="container-guttered">
        <div className="hero-ii-content-column">
          <RichText
            className="hero-ii-content"
            fields={props.content}
            color={props.contentColor}
          />
          <Extras
            icon={props.valuePropIcon}
            content={props.valuePropCopy}
            contentColor={props.contentColor}
          />
        </div>
      </div>
    </div>
  </section>
);

HeroII.propTypes = {
  backgroundImage: object.isRequired,
  backgroundColor: string.isRequired,
  content: array.isRequired,
  contentColor: string,
  valuePropIcon: string.isRequired,
  valuePropCopy: (props, propName) => {
    if (isUsingValueProps(props.valuePropIcon) && !isString(props[propName])) {
      return new Error(
        'A value prop icon was used, however the value prop copy was missing.',
      );
    }
  },
  mobileImageLayout: string.isRequired,
};

export default HeroII;



// WEBPACK FOOTER //
// ./src/client/js/view/components/HeroII/HeroII.js